import ReflectionCompletionRateTables from 'widgets/ReflectionCompletionRateTables/ReflectionCompletionRateTables'

export default ReflectionCompletionRateTables
